import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { useHasFiltersApplied, useSearchActions, useSearchResults } from '#src/app/pages/search/shared/searchState';

type Result = ModelHookResult<
	{
		hideButton: boolean;
	},
	{
		clearRefinements: () => void;
		trackClearFiltersClick: () => void;
	}
>;

export function useClearFilters(): Result {
	const results = useSearchResults();
	const actions = useSearchActions();
	const hasFilters = useHasFiltersApplied();
	const track = useTracking();

	const trackClearFiltersClick = useCallback(() => {
		void track('search_clear_filters_click');
		void track('search', { q: results.query || '', context: 'clear_filters_button' });
	}, [results.query, track]);

	return {
		data: {
			hideButton: !hasFilters,
		},
		actions: {
			clearRefinements: useCallback(() => {
				if (hasFilters) {
					actions.clearAllFilters();
				}
			}, [hasFilters, actions]),
			trackClearFiltersClick,
		},
	};
}
